import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

export default function Contact() {
    return (
        <>
            {/* Début section Contact */}
            <section className="section bg-light" id="contact">
                <Container>
                    <Row className="justify-content-center">
                        <Col>
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Contactez notre équipe</h4>
                                <p className="text-muted para-desc mb-0 mx-auto">
                                    Pour toute demande, assistance ou suggestion concernant votre résidence ou la gestion de votre immeuble, n'hésitez pas à nous écrire.
                                </p>
                            </div>
                        </Col>
                    </Row>

                    <Row className="align-items-center">
                        <Col lg={8} md={6} className="order-md-2 order-1 mt-4 pt-2">
                            <div className="p-4 rounded shadow bg-white">
                                <form method="post" name="formulaireContact">
                                    <p className="mb-0" id="error-msg"></p>
                                    <div id="simple-msg"></div>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-4">
                                                <input name="name" id="name" type="text" className="form-control" placeholder="Votre nom" required />
                                            </div>
                                        </Col>

                                        <Col md={6}>
                                            <div className="mb-4">
                                                <input name="email" id="email" type="email" className="form-control" placeholder="Votre email" required />
                                            </div>
                                        </Col>

                                        <div className="col-12">
                                            <div className="mb-4">
                                                <input name="subject" id="subject" className="form-control" placeholder="Objet du message" required />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="mb-4">
                                                <textarea name="comments" id="comments" rows={4} className="form-control" placeholder="Écrivez votre message ici..." required></textarea>
                                            </div>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="col-12 text-end">
                                            <button type="submit" id="submit" name="send" className="btn btn-primary">
                                                Envoyer le message
                                            </button>
                                        </div>
                                    </Row>
                                </form>
                            </div>
                        </Col>

                        <Col lg={4} md={6} className="col-12 order-md-1 order-2 mt-4 pt-2">
                            <div className="me-lg-4">
                                <div className="d-flex">
                                    <div className="icons text-center mx-auto">
                                        <i className="uil uil-phone d-block rounded h4 mb-0"></i>
                                    </div>
                                    <div className="flex-1 ms-3">
                                        <h5 className="mb-2">Téléphone</h5>
                                        <Link to="tel:+212612345678" className="text-muted">+212 6 12 34 56 78</Link>
                                    </div>
                                </div>

                                <div className="d-flex mt-4">
                                    <div className="icons text-center mx-auto">
                                        <i className="uil uil-envelope d-block rounded h4 mb-0"></i>
                                    </div>
                                    <div className="flex-1 ms-3">
                                        <h5 className="mb-2">Email</h5>
                                        <Link to="mailto:contact@syndicapp.ma" className="text-muted">contact@syndicapp.ma</Link>
                                    </div>
                                </div>

                                <div className="d-flex mt-4">
                                    <div className="icons text-center mx-auto">
                                        <i className="uil uil-map-marker d-block rounded h4 mb-0"></i>
                                    </div>
                                    <div className="flex-1 ms-3">
                                        <h5 className="mb-2">Adresse</h5>
                                        <p className="text-muted mb-2">Partout</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* Fin section Contact */}
        </>
    );
}
